import React, { useState, useEffect } from 'react';

const MobileTestPage = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [viewportInfo, setViewportInfo] = useState({});

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  useEffect(() => {
    const updateViewportInfo = () => {
      setViewportInfo({
        width: window.innerWidth,
        height: window.innerHeight,
        userAgent: navigator.userAgent,
        isMobile: window.innerWidth <= 768,
        hasTouch: 'ontouchstart' in window
      });
    };

    updateViewportInfo();
    window.addEventListener('resize', updateViewportInfo);
    return () => window.removeEventListener('resize', updateViewportInfo);
  }, []);

  return (
    <div className="mobile-test-page" style={{ background: '#f0f0f0', minHeight: '100vh' }}>
      
      {/* Debug Info Panel */}
      <div style={{
        position: 'fixed',
        top: '50px',
        left: '10px',
        background: '#000',
        color: '#fff',
        padding: '10px',
        borderRadius: '5px',
        fontSize: '11px',
        zIndex: 99998,
        maxWidth: '200px'
      }}>
        <strong>📱 DEBUG INFO:</strong><br/>
        Width: {viewportInfo.width}px<br/>
        Height: {viewportInfo.height}px<br/>
        Mobile: {viewportInfo.isMobile ? 'YES' : 'NO'}<br/>
        Touch: {viewportInfo.hasTouch ? 'YES' : 'NO'}<br/>
        Body classes: {document.body.className}
      </div>

      {/* Test Navbar */}
      <nav className="navbar" style={{ background: '#ff6b6b', color: 'white' }}>
        <div className="navbar-container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 1rem' }}>
          <div className="navbar-left" style={{ display: 'flex', alignItems: 'center' }}>
            <button className="menu-toggle" onClick={toggleSidebar} style={{ 
              background: 'transparent', 
              border: 'none', 
              color: 'white', 
              fontSize: '20px',
              marginRight: '10px'
            }}>
              ☰
            </button>
            <div className="navbar-brand" style={{ display: 'flex', alignItems: 'center' }}>
              <div className="brand-logo" style={{ 
                background: 'white', 
                color: '#ff6b6b', 
                width: '30px', 
                height: '30px', 
                borderRadius: '50%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                marginRight: '10px'
              }}>T</div>
              <span className="brand-text">TotsPal Mobile Test</span>
            </div>
          </div>
          <div className="navbar-right">
            <div className="auth-buttons" style={{ display: 'flex', gap: '10px' }}>
              <button className="btn btn-outline" style={{ background: 'transparent', border: '1px solid white', color: 'white', padding: '8px 16px' }}>Login</button>
              <button className="btn btn-primary" style={{ background: 'white', color: '#ff6b6b', border: 'none', padding: '8px 16px' }}>Sign Up</button>
            </div>
          </div>
        </div>
      </nav>

      {/* Test Sidebar */}
      <div className={`sidebar ${sidebarOpen ? 'active' : ''}`} style={{
        position: 'fixed',
        left: 0,
        top: 0,
        width: '280px',
        height: '100vh',
        background: 'white',
        boxShadow: '2px 0 10px rgba(0,0,0,0.1)',
        transform: sidebarOpen ? 'translateX(0)' : 'translateX(-100%)',
        transition: 'transform 0.3s ease',
        zIndex: 1000,
        padding: '20px'
      }}>
        <div className="sidebar-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <div className="logo">
            <h2>TotsPal</h2>
          </div>
          <button className="sidebar-close" onClick={toggleSidebar} style={{ background: 'none', border: 'none', fontSize: '24px' }}>
            ×
          </button>
        </div>
        <div className="sidebar-content">
          <nav className="sidebar-nav">
            <a href="#" className="nav-link active" style={{ display: 'block', padding: '10px', marginBottom: '5px', textDecoration: 'none', color: '#ff6b6b' }}>
              <span className="nav-icon">🏠</span> Home
            </a>
            <a href="#" className="nav-link" style={{ display: 'block', padding: '10px', marginBottom: '5px', textDecoration: 'none', color: '#333' }}>
              <span className="nav-icon">👥</span> Providers
            </a>
            <a href="#" className="nav-link" style={{ display: 'block', padding: '10px', marginBottom: '5px', textDecoration: 'none', color: '#333' }}>
              <span className="nav-icon">👶</span> Children
            </a>
            <a href="#" className="nav-link" style={{ display: 'block', padding: '10px', marginBottom: '5px', textDecoration: 'none', color: '#333' }}>
              <span className="nav-icon">📅</span> Calendar
            </a>
          </nav>
        </div>
      </div>

      {/* Test Main Content */}
      <div className="main-content" style={{ padding: '20px', background: '#f9f9f9' }}>
        <div className="page-container">
          
          {/* Test Hero Section */}
          <section className="hero-section" style={{ 
            background: 'linear-gradient(135deg, #ff6b6b, #4ecdc4)', 
            color: 'white', 
            padding: '40px 20px', 
            borderRadius: '10px', 
            marginBottom: '20px',
            textAlign: 'center'
          }}>
            <div className="hero-content">
              <h1 style={{ fontSize: '2rem', marginBottom: '10px' }}>Mobile Test Page</h1>
              <p className="hero-subtitle" style={{ marginBottom: '20px' }}>
                This page tests mobile responsiveness improvements for iOS Safari and other mobile browsers.
              </p>
              
              {/* Test Search Form */}
              <div className="home-search-container">
                <form className="home-search-form" style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                  <select className="search-type-select" style={{ flex: '1', minWidth: '200px', padding: '12px', border: 'none', borderRadius: '5px' }}>
                    <option>Find Providers</option>
                    <option>Find Babysitters</option>
                  </select>
                  <input 
                    type="text" 
                    className="search-input" 
                    placeholder="Enter location or provider name"
                    style={{ flex: '2', minWidth: '250px', padding: '12px', border: 'none', borderRadius: '5px' }}
                  />
                  <button type="submit" className="search-button" style={{ 
                    background: '#fff', 
                    color: '#ff6b6b', 
                    border: 'none', 
                    padding: '12px 24px', 
                    borderRadius: '5px',
                    cursor: 'pointer'
                  }}>
                    Search
                  </button>
                </form>
              </div>
              
              {/* Test CTA Buttons */}
              <div className="hero-cta" style={{ marginTop: '20px', display: 'flex', gap: '10px', flexWrap: 'wrap', justifyContent: 'center' }}>
                <button className="cta-button primary" style={{ 
                  background: 'white', 
                  color: '#ff6b6b', 
                  border: 'none', 
                  padding: '12px 24px', 
                  borderRadius: '5px',
                  cursor: 'pointer'
                }}>Get Started</button>
                <button className="cta-button secondary" style={{ 
                  background: 'transparent', 
                  color: 'white', 
                  border: '2px solid white', 
                  padding: '12px 24px', 
                  borderRadius: '5px',
                  cursor: 'pointer'
                }}>Learn More</button>
              </div>
            </div>
          </section>

          {/* Test Cards */}
          <section className="features-section">
            <h2>Mobile Card Testing</h2>
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon">📱</div>
                <h3>Mobile Responsive</h3>
                <p>This card should look great on mobile devices with proper spacing and touch targets.</p>
                <button className="btn btn-primary">Test Button</button>
              </div>
              <div className="feature-card">
                <div className="feature-icon">🎯</div>
                <h3>Touch Friendly</h3>
                <p>All interactive elements have minimum 44px touch targets for better usability.</p>
                <button className="btn btn-secondary">Another Button</button>
              </div>
              <div className="feature-card">
                <div className="feature-icon">🚀</div>
                <h3>iOS Safari Ready</h3>
                <p>Optimized specifically for iOS Safari with proper viewport handling.</p>
                <button className="btn btn-outline">Third Button</button>
              </div>
            </div>
          </section>

          {/* Test Form */}
          <section className="form-section" style={{ background: 'white', padding: '20px', borderRadius: '10px', marginBottom: '20px' }}>
            <h2>Mobile Form Testing</h2>
            <form>
              <div className="form-row" style={{ display: 'flex', gap: '15px', marginBottom: '15px' }}>
                <div className="form-group" style={{ flex: 1 }}>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>First Name</label>
                  <input type="text" placeholder="Enter first name" style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '5px' }} />
                </div>
                <div className="form-group" style={{ flex: 1 }}>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Last Name</label>
                  <input type="text" placeholder="Enter last name" style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '5px' }} />
                </div>
              </div>
              
              <div className="form-group" style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Email</label>
                <input type="email" placeholder="Enter email address" style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '5px' }} />
              </div>
              
              <div className="form-group">
                <label>Phone</label>
                <input type="tel" placeholder="Enter phone number" />
              </div>
              
              <div className="form-group">
                <label>Message</label>
                <textarea placeholder="Enter your message"></textarea>
              </div>
              
              <div className="form-actions" style={{ display: 'flex', gap: '10px' }}>
                <button type="submit" className="btn btn-primary" style={{ 
                  background: '#ff6b6b', 
                  color: 'white', 
                  border: 'none', 
                  padding: '12px 24px', 
                  borderRadius: '5px',
                  cursor: 'pointer',
                  flex: 1
                }}>Submit Form</button>
                <button type="button" className="btn btn-secondary" style={{ 
                  background: '#ddd', 
                  color: '#333', 
                  border: 'none', 
                  padding: '12px 24px', 
                  borderRadius: '5px',
                  cursor: 'pointer',
                  flex: 1
                }}>Cancel</button>
              </div>
            </form>
          </section>

          {/* Test Table */}
          <section className="card">
            <div className="card-header">
              <h3 className="card-title">Mobile Table Testing</h3>
            </div>
            <div className="card-body">
              <div className="mobile-table-cards">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Location</th>
                      <th>Rating</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td data-label="Name">Sarah Johnson</td>
                      <td data-label="Type">Babysitter</td>
                      <td data-label="Location">Downtown</td>
                      <td data-label="Rating">⭐⭐⭐⭐⭐</td>
                      <td data-label="Actions">
                        <div className="table-actions">
                          <button className="btn btn-sm btn-primary">View</button>
                          <button className="btn btn-sm btn-secondary">Contact</button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td data-label="Name">Mike Wilson</td>
                      <td data-label="Type">Daycare</td>
                      <td data-label="Location">Uptown</td>
                      <td data-label="Rating">⭐⭐⭐⭐</td>
                      <td data-label="Actions">
                        <div className="table-actions">
                          <button className="btn btn-sm btn-primary">View</button>
                          <button className="btn btn-sm btn-secondary">Contact</button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>

          {/* Test Modal Trigger */}
          <section style={{ background: 'white', padding: '20px', borderRadius: '10px', marginBottom: '20px' }}>
            <h3>Mobile Modal Testing</h3>
            <p>Test modal behavior on mobile devices:</p>
            <button onClick={toggleModal} style={{ 
              background: '#ff6b6b', 
              color: 'white', 
              border: 'none', 
              padding: '12px 24px', 
              borderRadius: '5px',
              cursor: 'pointer'
            }}>
              Open Modal
            </button>
          </section>

          {/* Test Features Grid */}
          <section className="card">
            <div className="card-header">
              <h3 className="card-title">Mobile Grid Testing</h3>
            </div>
            <div className="card-body">
              <div className="stats-grid">
                <div className="stat-card">
                  <div className="stat-value">150+</div>
                  <div className="stat-label">Providers</div>
                </div>
                <div className="stat-card">
                  <div className="stat-value">500+</div>
                  <div className="stat-label">Families</div>
                </div>
                <div className="stat-card">
                  <div className="stat-value">1000+</div>
                  <div className="stat-label">Bookings</div>
                </div>
                <div className="stat-card">
                  <div className="stat-value">4.9</div>
                  <div className="stat-label">Rating</div>
                </div>
              </div>
            </div>
          </section>

        </div>
      </div>

      {/* Test Modal */}
      {modalOpen && (
        <div className="modal" onClick={toggleModal} style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999
        }}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{
            background: 'white',
            padding: '20px',
            borderRadius: '10px',
            maxWidth: '500px',
            width: '90%',
            maxHeight: '80vh',
            overflow: 'auto'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
              <h3>Mobile Modal Test</h3>
              <button onClick={toggleModal} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer' }}>
                ×
              </button>
            </div>
            <div>
              <p>This modal should display properly on mobile devices:</p>
              <ul>
                <li>Full screen on mobile</li>
                <li>Proper touch targets</li>
                <li>iOS Safari safe areas</li>
                <li>Scrollable content</li>
              </ul>
              <button onClick={toggleModal} style={{ 
                background: '#ff6b6b', 
                color: 'white', 
                border: 'none', 
                padding: '12px 24px', 
                borderRadius: '5px',
                cursor: 'pointer',
                width: '100%',
                marginTop: '15px'
              }}>
                Close Modal
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Test Backdrop for Sidebar */}
      {sidebarOpen && (
        <div 
          className="sidebar-backdrop"
          onClick={toggleSidebar}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 999
          }}
        />
      )}
    </div>
  );
};

export default MobileTestPage; 